import { GameId, GAME_METADATAS } from '@mental-mint/shared-types';
import { Game, CommonPageId } from '@mental-mint/shared-ui';
import { waitForGrowthBookReady, GetTodaysDate, logger } from '@mental-mint/shared-utils';
import { craftegoryPageConfig, CraftegoryPageId } from './Pages/CraftegoryPageTypes';
import { craftegoryPageRegistry } from './Pages/CraftegoryPageRegistry';
import { loadCraftegory } from './Utils/saveManager';
import { getCraftegoryLevelId } from './Utils/puzzleUtils';

export const CRAFTEGORY_GAME: Game = {
  metadata: GAME_METADATAS[GameId.Craftegory],
  pageConfigs: craftegoryPageConfig,
  initialPageId: CraftegoryPageId.Play,
  pageRegistry: craftegoryPageRegistry,
  gameIconLarge: undefined,
  howToPlayGif: undefined,
  howToPlayText:
    'Combine two unlocked terms to discover a new one. Complete every constellation to win!',
  titleArt: undefined,
  fontPrimary: 'cubano, sans-serif',
  fontSecondary: 'Open Sans',
  colorPrimary: '#6366f1',
  colorSecondary: '#1e1e2e',
  colorUiBackground: '#0f0f1a',
};

export async function getCraftegoryGame(): Promise<Game> {
  const initialModalPageIds: string[] = [];

  try {
    await waitForGrowthBookReady();
    const saveData = await loadCraftegory();
    const todaysDate = GetTodaysDate();
    const levelId = getCraftegoryLevelId(todaysDate);
    const score = saveData.levelScores[levelId];

    if (score?.isWon) {
      logger.debug('[Craftegory] Today already won — showing Victory modal first');
      initialModalPageIds.push(CraftegoryPageId.Victory);
    } else {
      initialModalPageIds.push(CraftegoryPageId.PuzzleIntro);
    }
  } catch (error) {
    logger.error('[Craftegory] Failed to determine initial modals:', error);
    initialModalPageIds.push(CraftegoryPageId.PuzzleIntro);
  }

  return {
    ...CRAFTEGORY_GAME,
    initialModalPageIds,
  };
}
